import request from '@/utils/request'

let BonusApi = {
    /*列表*/
    getProduct(data) {
        return request._get('/shop/plus.bonus.product/index', data);
    },
    /*添加*/
    addProduct(data) {
        return request._post('/shop/plus.bonus.product/add', data);
    },
    /*编辑*/
    editProduct(data) {
        return request._post('/shop/plus.bonus.product/edit', data);
    },
    /*删除*/
    delProduct(data) {
        return request._post('/shop/plus.bonus.product/delete', data);
    },
    /*获取设置*/
    getSetting(data) {
        return request._get('/shop/plus.bonus.setting/index', data);
    },
    /*保存设置*/
    saveSetting(data) {
        return request._post('/shop/plus.bonus.setting/index', data);
    },

}

export default BonusApi;



// WEBPACK FOOTER //
// ./src/api/bonus.js